export const GroupJoinRequestStatus = {
	PENDING: "pending",
	APPROVED: "approved",
	DENIED: "denied",
	CANCELLED: "cancelled",
} as const;
export type GroupJoinRequestStatus = (typeof GroupJoinRequestStatus)[keyof typeof GroupJoinRequestStatus];

export const GroupJoinRequestDecision = {
	APPROVE: "approve",
	DENY: "deny",
} as const;
export type GroupJoinRequestDecision = (typeof GroupJoinRequestDecision)[keyof typeof GroupJoinRequestDecision];
